import React, { useEffect, useState } from "react";
import "../styles/MobileStickyCta.css";
import { useLanguage } from "../contexts/LanguageContext";

const MobileStickyCta = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const { whatsapp, whatsappPrefill } = text.contactDetails;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const heroHeight = window.innerHeight * 0.6;
      const nearBottom =
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200;
      setVisible(window.scrollY > heroHeight && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const number = whatsapp ? whatsapp.replace(/[^\d]/g, "") : "";
  const waUrl = number
    ? `https://wa.me/${number}?text=${encodeURIComponent(whatsappPrefill)}`
    : "#contact";

  return (
    <div
      className={`mobile-sticky-cta ${visible ? "is-visible" : ""}`}
      dir={isHeb ? "rtl" : "ltr"}
      aria-hidden={!visible}
    >
      <a className="msc-btn msc-btn-primary" href="#contact">
        {text.mobileSticky.primary}
      </a>
      <a
        className="msc-btn msc-btn-wa"
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20.52 3.48A11.94 11.94 0 0 0 12.06 0C5.46 0 .12 5.34.12 11.94c0 2.1.55 4.16 1.6 5.97L0 24l6.27-1.64a11.95 11.95 0 0 0 5.79 1.48h.01c6.6 0 11.94-5.34 11.94-11.94 0-3.19-1.24-6.18-3.49-8.42zm-8.46 18.36h-.01a9.93 9.93 0 0 1-5.06-1.39l-.36-.21-3.72.98 1-3.63-.24-.37a9.93 9.93 0 0 1-1.52-5.28c0-5.49 4.47-9.96 9.96-9.96 2.66 0 5.16 1.04 7.04 2.92a9.9 9.9 0 0 1 2.92 7.04c0 5.49-4.47 9.96-9.96 9.96z" />
        </svg>
        {text.mobileSticky.secondary}
      </a>
    </div>
  );
};

export default MobileStickyCta;
